import React, { FC, useState } from 'react'
import { connect } from 'react-redux'
import { CSSTransition } from 'react-transition-group'
import { IState } from '../../state/types'

interface Props { }

const ForwardingWidget: FC<Props> = ({ }: Props) => {
  const [show, setShow] = useState<boolean>(false)
  const [color, setColor] = useState<string>('')
  const [message, setMessage] = useState<string>('')
  const [link, setLink] = useState<string>('')

  React.useEffect(() => {
    document.addEventListener('forwardingMessage', handleShow)
  }, [])

  const handleShow = (e: any) => {
    setMessage(e.detail.message)
    setLink(e.detail.link)
    setColor(e.detail.color ? e.detail.color : 'warning')
    setShow(true)
  }

  const handleClose = async () => {
    setShow(false)
  }

  return (
    <CSSTransition in={show} timeout={200} classNames="slide-up" unmountOnExit>
      <div className={`update-widget bg-${color}`}>
        <div className="row p-3 ">
          <div className="text-break d-flex col-6 col-sm-8 align-items-center">
            {message}
            <div className="align-self-center"></div>
          </div>
          {link && (
            <div className="d-flex col-4 col-sm-2 align-items-center">
              <a
                className="btn btn-sm btn-outline-light"
                href={link}
                target="_blank"
              >
                redirect
              </a>
            </div>
          )}
          <div className="d-flex col-4 col-sm-2 align-items-center">
            <button
              className="btn btn-sm btn-outline-light"
              onClick={handleClose}
            >
              dismiss
            </button>
          </div>
        </div>
      </div>
    </CSSTransition>
  )
}

export default connect((state: IState) => ({}))(ForwardingWidget)